import { RecordingComponent } from "./recording.component";
import { RecordingSchedulerComponent } from "./recording-scheduler/recording-scheduler.component";
import { RecordingHistoryComponent } from "./recording-history/recording-history.component";
import { RecordingManagerGuard } from "../../guards/permission.guard";

export const RecordingRoutes = [
  {
    path: "recording",
    component: RecordingComponent,
    canActivate: [RecordingManagerGuard],
    children: [
      { path: "schedule", component: RecordingSchedulerComponent },
      { path: "history", component: RecordingHistoryComponent },
      { path: "", component: RecordingSchedulerComponent },
    ],
  },
];
